import { Component, OnInit } from '@angular/core';
import { BatchUpload } from 'src/app/models/upload/BatchUpload';

@Component({
  selector: 'app-batch-upload-modal',
  templateUrl: './batch-upload-modal.page.html',
  styleUrls: ['./batch-upload-modal.page.scss'],
})
export class BatchUploadModalPage implements OnInit {

  public batchUpload: BatchUpload;
  public modalTitle: string;
  public modalDescription: string;

  constructor() { }

  ngOnInit() {
  }

}
